import React from "react";
import { Modal, StyleSheet, TouchableOpacity, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import DeliveryCodeNotGenerated from "./DeliveryCodeNotGenerated";

const DeliveryCodeModal = ({
  visible,
  setVisible,
  spokeDeliveryReturnDetails,
}) => {
  const insets = useSafeAreaInsets();
  const { deliveryBoyInfo } =
    spokeDeliveryReturnDetails?.deliveryDetails ||
    spokeDeliveryReturnDetails?.returnDetails ||
    {};

  return (
    <Modal
      transparent={true}
      visible={visible}
      statusBarTranslucent
      navigationBarTranslucent
    >
      <View style={{ flex: 1 }}>
        <TouchableOpacity
          testID="dcm-close"
          onPress={() => setVisible(false)}
          style={{ backgroundColor: "rgba(0,0,0,0.4)", flex: 1 }}
        />
        <View
          style={[styles.modalWrapper, { paddingBottom: insets.bottom + 5 }]}
        >
          {deliveryBoyInfo && (
            <DeliveryCodeNotGenerated deliveryBoyInfo={deliveryBoyInfo} />
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalWrapper: {
    backgroundColor: "white",
    flex: 1,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    padding: 5,
    position: "absolute",
    bottom: 0,
    minHeight: 300,
  },
});

export default DeliveryCodeModal;
